<template>
    <ul class="ed-dropdown-menu__content">
      <slot></slot>
    </ul>
</template>

<script>
  export default {
    name: 'DropdownContent',
  };
</script>



// WEBPACK FOOTER //
// dropdownMenuContent.vue?75fa506e